export default class CityFactory {
  create() {
    return {
      id: null,
      name: '',
    }
  }
}
